import dayjs from 'dayjs';
import { DateInput } from '@mantine/dates';
import { Button, Paper, Grid, Select, Stack, Stepper, Center, Divider } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import TableWithLoaderConciliaciones from '../CustomComponents/TableWtithLoaderConciliaciones';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';


const dateParser = (input) => {
    if (input === 'WW2') {
        return '1939-09-01';
    }
    return dayjs(input, 'DD/MM/YYYY').format('YYYY-MM-DD');
};


const DatePanelConcilines = () => {
    const [allData, setAllData] = useState([]);
    const [headerst, setHeaders] = useState([]);

    const [makeRequest, setMakeRequest] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectData, setDataSelect] = useState([]);
    const [selectedValue, setSelectedValue] = useState(0);


    const [stepperVisible, setStepperVisible] = useState(false);
    const [stepperActive, setStepperActive] = useState(0);
    const [stepperError, setStepperError] = useState(false);
    const [stepperLoading, setStepperLoading] = useState(false);
    const [stepperStatus, setStepperStatus] = useState('Listo');

    useEffect(() => {
        fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/conciliaciones/getConciliaciones",
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error getting info: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setDataSelect(data);
            })
            .catch((err) => {
                showNotification({
                    title: 'Error!',
                    message: err.response?.data?.error ? err.response.data.error : err.message,
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#E93F19',
                            borderColor: 'E93F19',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                })
            })
            .finally(() => {
                //setLoading(false);
            });
    }, []);

    const consultarReporte = () => {        
        if (selectedValue == 0) {
            showNotification({
                title: 'Error!',
                message: "Debe seleccionar una opción valida",
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        } else {
            fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3LinkConciliaciones?id=" + selectedValue,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                        "Content-Type": "application/json",
                    },
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error while getting S3 link! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    const s3Url = data?.link; // Adjust based on the actual response structure                                    
                    if (!s3Url) throw new Error("S3 URL not found in response");
                    return fetch(s3Url);
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error while fetching S3 data! status: ${response.status}`);
                    }
                    return response.json(); // Assuming the file on S3 is JSON
                })
                .then((json) => {                    
                    setAllData(json);
                    const headers = Array.from(
                        new Set(json.flatMap(obj => Object.keys(obj)))
                    );
                    setHeaders(headers);
                })
                .catch((err) => {
                    showNotification({
                        title: 'Error!',
                        message: err.response?.data?.error ? err.response.data.error : err.message,
                        color: '#fff',
                        styles: (theme) => ({
                            root: {
                                backgroundColor: '#E93F19',
                                borderColor: 'E93F19',
                                '&::before': { backgroundColor: theme.white },
                            },
                            title: { color: theme.white },
                            description: { color: theme.white },
                            closeButton: {
                                color: theme.white,
                            },
                        }),
                        autoClose: false,
                    })
                })
                .finally(() => {
                    setMakeRequest(true);
                });
        }

    }

    const crearReporte = async () => {

        if (selectedValue == 0 || startDate == null || endDate == null) {
            showNotification({
                title: 'Error!',
                message: "Debe seleccionar una opción valida",
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        } else {

            try {
                const response = await axios.post(process.env.REACT_APP_API_ENP + "/sscn-back/api/conciliaciones/generarConcilicaion",
                    { "id": selectedValue, "fecha_inicio": startDate, "fecha_fin": endDate },
                    {
                        headers: {
                            Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                        }
                    }
                );

                if (response.status == 202)
                    showNotification({
                        title: 'Listo!',
                        message: 'Peticion generada con exito',
                        color: '#fff',
                        styles: (theme) => ({
                            root: {
                                backgroundColor: '#25A661',
                                borderColor: '#25A661',
                                '&::before': { backgroundColor: theme.white },
                            },
                            title: { color: theme.white },
                            description: { color: theme.white },
                            closeButton: {
                                color: theme.white,
                            },
                        }),
                        autoClose: false,
                    })
            } catch (err) {

                showNotification({
                    title: 'Error!',
                    message: err.response?.data?.message ? err.response.data.message : err.message,
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#E93F19',
                            borderColor: 'E93F19',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                })
            }
        }
    }


    const handleExecuteAPIProcess = async () => {        

        if (selectedValue == 0 || startDate == null || endDate == null) {
            showNotification({
                title: 'Error!',
                message: "Debe seleccionar una opción valida",
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        } else {
            try {
                // 🧩 Step 1: Trigger the stored procedure
                const response = await axios.post(process.env.REACT_APP_API_ENP + "/sscn-back/api/conciliaciones/generarConcilicaion",
                    { "id": selectedValue, "fecha_inicio": startDate, "fecha_fin": endDate },
                    {
                        headers: {
                            Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                        }
                    }
                );

                setStepperVisible(true);
                setStepperLoading(true);
                setStepperStatus('Tarea aceptada, comienza a procesar');
                setStepperActive(1);
                setStepperError(false);


                // 🧩 Step 2: Poll the status every 30 seconds
                const interval = setInterval(async () => {
                    try {                        
                        const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/conciliaciones/getStatusConciliaciones",
                            {
                                params: {
                                    id: selectedValue,
                                }
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                                }
                            }
                        );

                        if (data.SEMAFORO == 1) {

                            setStepperLoading(true);
                            setStepperStatus(data.ESTATUS_SEMAFORO);
                            setStepperActive(1);
                            setStepperError(false);
                        }

                        if (data.SEMAFORO == 0) {
                            setStepperLoading(false);
                            setStepperStatus('Archivo Listo para descarga');
                            setStepperActive(3);
                            setStepperError(false);
                            consultarReporte();
                            clearInterval(interval);
                        }

                        if (data.SEMAFORO == 2) {
                            setStepperLoading(false);
                            setStepperStatus(data.ESTATUS_SEMAFORO);
                            setStepperActive(2);
                            setStepperError(true);
                            clearInterval(interval);
                        }

                    } catch (pollErr) {
                        console.error('Polling error:', pollErr);
                        setStepperLoading(false);
                        setStepperStatus(pollErr);
                        setStepperActive(2);
                        setStepperError(true);
                        clearInterval(interval);
                    }
                }, 5_000);
            } catch (err) {                
                setStepperLoading(false);
                setStepperStatus(err);
                setStepperActive(2);
                setStepperError(true);
            }
        }
    };


    return (
        <>

            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md">
                    <Paper shadow="xl" radius="xl" withBorder p="xl">
                        {selectData.length === 0 ? null : (
                            <>
                                <Grid justify="center" align="center">
                                    <Grid.Col span={6}>
                                        <Select
                                            label="Elige opción"
                                            data={selectData.map(item => ({
                                                value: String(item.Id),
                                                label: item.Name
                                            }))}
                                            searchable
                                            onChange={(value) => {
                                                setSelectedValue(Number(value));
                                            }}
                                        />
                                    </Grid.Col>
                                </Grid>
                                {/* <Grid justify="center" align="center">
                                    <Grid.Col span={1} >
                                        <Button variant="outline" color="rgba(2, 12, 65, 1)" onClick={consultarReporte}>Consultar</Button>
                                    </Grid.Col>
                                </Grid> */}
                            </>
                        )}

                        <Grid justify="center" align="center">
                            <Grid.Col span={3}>
                                <DateInput
                                    value={startDate}                // controlled value
                                    onChange={setStartDate}
                                    dateParser={dateParser}
                                    valueFormat="YYYY/MM/DD"
                                    label="Fecha Inicio"
                                    placeholder="YYYY/MM/DD"
                                />
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <DateInput
                                    value={endDate}                // controlled value
                                    onChange={setEndDate}
                                    dateParser={dateParser}
                                    valueFormat="YYYY/MM/DD"
                                    label="Fecha Fin"
                                    placeholder="YYYY/MM/DD"
                                />
                            </Grid.Col>
                        </Grid>

                        <Grid justify="center" align="center">
                            <Grid.Col span={1} >
                                {/* <Button variant="outline" color="rgba(2, 12, 65, 1)" onClick={crearReporte} >Generar</Button> */}
                                <Button variant="outline" color="rgba(2, 12, 65, 1)" onClick={handleExecuteAPIProcess} >Generar</Button>
                            </Grid.Col>
                        </Grid>
                        <Divider my="md" />
                        {/* ---- Stepper ---- */}
                        {
                            stepperVisible ?
                                (<Grid justify="center" align="center">
                                    <Grid.Col span={10} style={{ margin: 'auto' }}>
                                        <Stepper
                                            active={stepperActive}
                                            allowNextStepsSelect={false}
                                        >
                                            <Stepper.Step
                                                label="Inicio"
                                                description="Proceso Iniciado"
                                                completedIcon={stepperError && stepperActive === 1 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                                                color={stepperError && stepperActive === 1 ? 'red' : undefined}
                                            />
                                            <Stepper.Step
                                                label="Procesando"
                                                description="Generando el archivo en la nube"
                                                completedIcon={stepperError && stepperActive === 2 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                                                color={stepperError && stepperActive === 2 ? 'red' : undefined}
                                                loading={stepperLoading && stepperActive === 1 ? true : false}
                                            />
                                            <Stepper.Step label="Listo!" description="El archivo esta listo para ser descargado" />
                                        </Stepper>

                                        {/* ---- Status & Loader ---- */}
                                        <Center mt="lg">
                                            <p>Status: {stepperStatus}</p>
                                        </Center>

                                    </Grid.Col>
                                </Grid>) : <></>
                        }
                    </Paper>
                    {/* si alldata esta vacio entonces no se renderiza nada se oculta esta tabla */}
                    {makeRequest !== false ? <TableWithLoaderConciliaciones heigth={500} allData={allData} headers={headerst} selectedValue={selectedValue} /> : <></>}

                </Stack>
            </div>
        </>
    );
};

export default DatePanelConcilines;